import {
  Action_SaveBanHang,
  Action_SaveBanHangSuccess,
  Action_SaveBanHangFailed,
  Action_GetBanHangPrint,
  Action_GetBanHangPrintSuccess
} from "actions/BanHang/BanHang/actionTypes";
import Config from "constants/configs";

const initialState = {
  isSaveOk: false,
  iStatus: Config.sTrangThaiRequestAPI.ChuaGoi,
  objData:{},
  OrderID: ""
};

const Reducer_AddOrUpdateBanHang = (state, action) => ({
  ...state,
  iStatus: Config.sTrangThaiRequestAPI.DangGoi,
  OrderID: 0
});
const Reducer_AddOrUpdateBanHangSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iStatus: Config.sTrangThaiRequestAPI.Success,
    OrderID: action.payload,
  };
};
const Reducer_AddOrUpdateBanHangFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iStatus: Config.sTrangThaiRequestAPI.Failed,
  };
};

const Reducer_GetBanHangPrint = (state, action) => ({
  ...state,
  iStatus: Config.sTrangThaiRequestAPI.DangGoi,
  OrderID: 0
});
const Reducer_GetBanHangPrintSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iStatus: Config.sTrangThaiRequestAPI.Success,
    objData: action.payload,
  };
};

// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_SaveBanHang:
      return Reducer_AddOrUpdateBanHang(state, action);
    case Action_SaveBanHangSuccess:
      return Reducer_AddOrUpdateBanHangSuccess(state, action);
    case Action_SaveBanHangFailed:
      return Reducer_AddOrUpdateBanHangFalse(state, action);

    case Action_GetBanHangPrint:
      return Reducer_GetBanHangPrint(state, action);
    case Action_GetBanHangPrintSuccess:
      return Reducer_GetBanHangPrintSuccess(state, action);

      
    default:
      return state;
  }
};
export default authReducer;
